// src/components/Logo.jsx
import React from 'react';

export default function LogoComponent() {
  return (
    <img
      src="/Zirkle-Vigilant.png" 
      alt="Company logo"
      style={{ width: 800, height: 'auto', paddingTop: 30 }}
    />
  );
}
